import type { AxiosError } from 'axios';

interface ApiErrorResponse {
  message?: string | string[];
  error?: string;
  statusCode?: number;
}

/**
 * Extract the error message from an API error response.
 * Handles the standard API format: { message, error, statusCode }
 * Supports both string and array message formats.
 */
export function getApiErrorMessage(error: unknown, fallback = 'Unknown error'): string {
  const axiosError = error as AxiosError<ApiErrorResponse>;
  const data = axiosError?.response?.data;

  if (data?.message) {
    return Array.isArray(data.message) ? data.message[0] ?? fallback : data.message;
  }

  if (data?.error) {
    return data.error;
  }

  if (axiosError?.message) {
    return axiosError.message;
  }

  return fallback;
}
